import Router from '@/router'
import amapi from '@/api/amapi'

export default {
  navigateTo (store, hostingid) {
    const service = store.getters.services.filter(x => { return x.id === hostingid })
    const types = {
      dserver: 'dedicated',
      vserver: 'vps',
      cpanel: 'shared',
      whm: 'reseller',
    }
    if (service.length) {
      const serviceType = types[service[0].type]
      store.commit('POPULATE_HOSTING', service[0])
      Router.push({ path: '/hosting/' + serviceType + '/' + service[0].id })
    } else {
      return new Error('Unknown Service')
    }
  },
  async getHosting (store, hostingid) {
    store.commit('POPULATE_HOSTING')
    store.commit('POPULATE_HOSTING_DETAIL')
    if (!store.getters.services || !store.getters.services.length) {
      await store.dispatch('getServices')
    }
    let service = store.getters.services.filter(service => {
      return service.id === hostingid
    })
    if (service.length) {
      store.commit('POPULATE_HOSTING', service[0])
      return service[0]
    } else {
      throw new Error('UNK_SRV')
    }
  },
  async setHostingPassword ({ dispatch, state }, params) {
    const data = {
      id: state.hosting.id,
      password: '',
      update_only: 0
    }
    if (typeof params === 'object') {
      data.password = params.pass
      data.update_only = params.update_only
      data.username = params.username
    } else {
      data.password = params
    }
    if (!data.password) {
      throw new Error('Password does not meet complexity requirements')
    }
    try {
      await amapi.makecall('service_setpassword', data)
      return 'Password successfully saved.'
    } catch (e) {
      throw e
    }
  },
  /**
   * Get hosting details
   * @param {Object} context
   * @param {Object | String} payload
   */
  async getHostingDetail ({ dispatch, commit, state }, payload = {}) {
    const user = typeof payload === 'string' ? payload : payload?.user || ''
    // const isResellerRoute = payload?.isResellerRoute || false

    try {
      if (state.hosting === null) {
        return Error('Unknown service')
      }

      const service_id = state.hosting.id
      let api_method
      commit('POPULATE_HOSTING_ERROR', null)
      const serviceType = state.hosting.type
      switch (serviceType) {
        case 'cpanel':
          api_method = 'cpanel_accountdetail'
          break
        case 'dserver':
          api_method = 'dserver_detail'
          break
        case 'vserver':
          api_method = 'vserver_detail'
          break
        case 'whm':
          // state.hosting.username is reseller's main account
          api_method = user && state.hosting?.username !== user ? 'cpanel_accountdetail' : 'whm_accountdetail'
      }
      const response = await amapi.makecall(api_method, {
        id: service_id,
        username: user
      })
      commit('POPULATE_HOSTING_DETAIL', response)
      if (api_method === 'whm_accountdetail' && response.accounts && response.accounts.length) {
        commit('SET_RESELLER_SUB_ACCOUNTS', response.accounts)
        dispatch('fetchResellerPrivileges', response.user)
      }
      if (serviceType !== 'vserver' || user) {
        await dispatch('getHostingDomains', user)
      }
    } catch (e) {
      commit('POPULATE_HOSTING_ERROR', e)
      throw e
    }
  },
  async getcpanelloginurl (store, { id, username = '' }) {
    try {
      const data = {
        id,
        username: username ?? undefined
      }
      const response = await amapi.makecall('cpanel_loginurl', { ...data })
      if (response.cpanel_url) {
        return Promise.resolve(response.cpanel_url)
      } else {
        return Promise.reject(response)
      }
    } catch (e) {
      throw e
    }
  },
  async getPhpMyAdmiUurl (store, { id, _username }) {
    try {
      const data = {
        service: id,
        username: _username,
      }
      const { url } = await amapi.makecall('phpmyadmin_login', { ...data })

      return url
    } catch (e) {
      throw e
    }
  },
  async getwhmloginurl (store, params) {
    try {
      const data = {
        id: params
      }
      const response = await amapi.makecall('whm_loginurl', { ...data })
      if (response.whm_url) {
        return Promise.resolve(response.whm_url)
      } else {
        return Promise.reject(response)
      }
    } catch (e) {
      throw e
    }
  },
  async getWebmailLoginUrl (store, { serviceID, email }) {
    const data = {
      serviceID,
      email
    }
    try {
      return await amapi.makecall('webmail_loginurl', data)
    } catch (e) {
      throw e
    }
  },
  async getFilemanLoginUrl (store, { serviceId, username }) {
    try {
      const data = {
        service: serviceId,
        username: username,
      }
      const { url } = await amapi.makecall('filemanager_login', data)

      return url
    } catch (e) {
      throw e
    }
  },
  async vserver_reboot (store) {
    try {
      const data = {
        id: store.state.hosting.id
      }
      return amapi.makecall('vserver_reboot', { ...data })
    } catch (e) {
      throw e
    }
  },
  async makecall ({ dispatch }, payload) {
    try {
      return amapi.makecall(payload.method, { ...payload.data })
    } catch (e) {
      throw e
    }
  },
  // Moved to amapi.js
  //
  async cpanel_uapi (store, params) {
    const data = {
      id: store.state.hosting.id,
      params,
      username: params._username,
    }
    try {
      return amapi.makecall('cpanel_uapi', data)
    } catch (e) {
      throw e
    }
  },
  // https://www.softaculous.com/docs/api/api/
  softaculous_api (store, params) {
    return amapi.softaculous_api(params)
  },
  async cpanel_api2 (store, params) {
    const data = {
      id: store.state.hosting.id,
      username: params._username,
      params: {
        ...params,
        _username: undefined,
      },
    }
    try {
      return amapi.makecall('cpanel_api2', data)
    } catch (e) {
      throw e
    }
  },
  async cpanel_domainlist (store, params) {
    try {
      const data = {
        id: store.state.hosting.id,
        params
      }
      return amapi.makecall('cpanel_domainlist', { ...data })
    } catch (e) {
      throw e
    }
  },
  // https://documentation.cpanel.net/display/DD/UAPI+Functions+-+DomainInfo%3A%3Adomains_data
  async getHostingDomains ({ dispatch, commit }, _username) {
    try {
      const data = {
        uapi_module: 'DomainInfo',
        uapi_function: 'domains_data',
        _username,
      }
      // const response = await dispatch('cpanel_uapi', { ...data })
      const response = await amapi.cpanel_uapi(data)
      commit('POPULATE_HOSTING_DOMAINS', response.data)
    } catch (e) {
      console.log(e)
      throw e
    }
  },
  async ipUpdate ({ dispatch }, payload) {
    try {
      return amapi.makecall('ip_update', payload)
    } catch (e) {
      throw e
    }
  },
  /**
   * Request a Softaculous installation’s application login session.
   *
   * @param commit
   * @param service
   * @param installation
   * @param data
   * @returns {Promise<void>}
   */
  async soft_login ({ commit }, { service, installation }) {
    try {
      const { url } = await amapi.makecall('soft_login', { service, installation })

      return url
    } catch (e) {
      throw e
    }
  },

  async suspendSubAccount ({ dispatch }, user) {
    try {
      await amapi.whmapi({
        action: 'suspendacct',
        user,
      })
      dispatch('reportSuccess', `Subaccount "${user}" was suspended`)
    } catch (e) {
      dispatch('reportError', e)
    }
  },

  async unsuspendSubAccount ({ dispatch }, user) {
    try {
      await amapi.whmapi({
        action: 'unsuspendacct',
        user,
      })
      dispatch('reportSuccess', `Subaccount "${user}" was unsuspended`)
    } catch (e) {
      dispatch('reportError', e)
    }
  },

  async removeSubAccount ({ dispatch }, user) {
    try {
      await amapi.whmapi({
        action: 'removeacct',
        user,
      })
      dispatch('reportSuccess', `Subaccount "${user}" was removed`)
    } catch (e) {
      dispatch('reportError', e)
    }
  },

  /**
   * Navigate to sub account if user provided
   * @param store
   * @param id service id
   * @param user sub account's username
   * @returns {Error}
   */
  navigateToSubAccount (store, { id, user }) {
    const service = store.getters.services.filter(x => { return x.id === id.toString() })
    const types = {
      dserver: 'dedicated',
      vserver: 'vps',
      cpanel: 'shared',
      whm: 'reseller',
    }
    if (service.length) {
      // user applies only for reseller's sub account. Reseller's sub account service is shared
      const serviceType = user ? types.cpanel : types[service[0].type]
      store.commit('POPULATE_HOSTING', service[0])
      Router.push({ path: '/hosting/' + serviceType + '/' + service[0].id, query: { user } })
    } else {
      return new Error('Unknown Service')
    }
  },

  async createAccountForReseller ({ dispatch }, data) {
    try {
      const response = await amapi.whmapi({
        action: 'createacct',
        ...data,
      })
      dispatch('reportSuccess', `Subaccount was added`)
      dispatch('getHostingDetail')
      return response
    } catch (e) {
      dispatch('reportError', e)
    }
  },

  async fetchResellerPackages ({ dispatch, commit }, user) {
    try {
      const response = await amapi.whmapi({
        action: 'listpkgs',
        user,
      })
      commit('SET_RESELLER_PACKAGES', response.data.data.pkg)
    } catch (e) {
      dispatch('reportError', e)
    }
  },

  async fetchResellerFeatureLists ({ dispatch, commit }, user) {
    try {
      const response = await amapi.whmapi({
        action: 'get_featurelists',
        user,
      })
      commit('SET_RESELLER_FEATURE_LISTS', response.data.data.featurelists)
    } catch (e) {
      dispatch('reportError', e)
    }
  },

  async updateSettings ({ dispatch, commit }, data) {
    try {
      await amapi.whmapi({
        action: 'modifyacct',
        ...data
      })
      dispatch('getHostingDetail')
    } catch (e) {
      dispatch('reportError', e)
    }
  },

  async changeAccountHostingPlan ({ dispatch, commit }, data) {
    try {
      await amapi.whmapi({
        action: 'changepackage',
        ...data
      })
      dispatch('getHostingDetail')
    } catch (e) {
      dispatch('reportError', e)
    }
  },

  async fetchResellerThemes ({ dispatch, commit }, { id }) {
    try {
      const data = {
        id,
        params: {
          api2_module: 'Themes',
          api2_method: 'get_available_themes',
        }
      }
      const response = await amapi.makecall('cpanel_api2', { ...data })
      commit('SET_RESELLER_THEMES', response.payload.data)
    } catch (e) {
      dispatch('reportError', e)
    }
  },

  async createResellerPackage ({ dispatch }, data) {
    try {
      await amapi.whmapi({
        action: 'addpkg',
        ...data,
      })
      dispatch('reportSuccess', 'Package created')
    } catch (e) {
      dispatch('reportError', e)
      return false
    }
  },

  async updateResellerPackage ({ dispatch }, data) {
    try {
      await amapi.whmapi({
        action: 'editpkg',
        ...data,
      })
      dispatch('reportSuccess', 'Package update')
    } catch (e) {
      dispatch('reportError', e)
      return false
    }
  },

  async deleteResellerPackage ({ dispatch }, data) {
    try {
      await amapi.whmapi({
        action: 'killpkg',
        ...data,
      })
      dispatch('reportSuccess', 'Package deleted')
    } catch (e) {
      dispatch('reportError', e)
      return false
    }
  },

  async fetchResellerFeatures ({ dispatch, commit }) {
    try {
      const response = await amapi.whmapi({ action: 'get_feature_metadata' })
      commit('SET_RESELLER_FEATURES', response.data.data.features)
    } catch (e) {
      dispatch('reportError', e)
    }
  },

  async fetchFeatureListData ({ dispatch }, data) {
    try {
      const response = await amapi.whmapi({ action: 'get_featurelist_data', ...data })
      return response.data.data
    } catch (e) {
      dispatch('reportError', e)
    }
  },

  async createResellerFeatureList ({ dispatch }, data) {
    try {
      await amapi.whmapi({ action: 'create_featurelist', ...data })
      dispatch('reportSuccess', 'Feature List added')
    } catch (e) {
      dispatch('reportError', e)
      return false
    }
  },

  async updateResellerFeatureList ({ dispatch }, data) {
    try {
      await amapi.whmapi({ action: 'update_featurelist', ...data })
      dispatch('reportSuccess', 'Feature List updated')
    } catch (e) {
      dispatch('reportError', e)
      return false
    }
  },

  async deleteResellerFeatureList ({ dispatch }, data) {
    try {
      await amapi.whmapi({ action: 'delete_featurelist', ...data })
      dispatch('reportSuccess', 'Feature List deleted')
    } catch (e) {
      dispatch('reportError', e)
      return false
    }
  },

  async fetchResellerPrivileges ({ dispatch, commit }, user) {
    try {
      const response = await amapi.whmapi({
        action: 'myprivs',
        user,
      })
      commit('SET_RESELLER_PRIVILEGES', response.data.data.privileges[0])
    } catch (e) {
      dispatch('reportError', e)
    }
  },

  async fetchResellerZones ({ dispatch, commit }) {
    try {
      const res = await amapi.whmapi({ action: 'listzones' })
      // https://api.docs.cpanel.net/openapi/whm/operation/listzones/
      commit('SET_RESELLER_ZONES', Array.isArray(res.data.data.zone) ? res.data.data.zone : [])
    } catch (e) {
      dispatch('reportError', e)
    }
  }

}
